/* eslint-disable react/jsx-key -- keys are not needed for child routes */
import React from 'react';
import { Route, IndexRedirect } from '@americanexpress/one-app-router';
import ModuleRoute from 'holocron-module-route';
import onEnterBankingAccounts from './utils/onEnterBankingAccounts';
import onEnterCheckbookOrder from './utils/onEnterCheckbookOrder';
import ErrorMessage from './components/ErrorMessage';
import { Dls6Wrapper, Dls7Wrapper } from './components/DlsWrapper';

const childRoutes = (store) => {
  return [
    <ModuleRoute component={Dls6Wrapper}>
      <ModuleRoute path="demo/:moduleName" moduleName="axp-demo" />
    </ModuleRoute>,
    <ModuleRoute component={Dls7Wrapper}>
      <ModuleRoute path="demo/dls7/:moduleName" moduleName="axp-demo" />
    </ModuleRoute>,
    <Route path="/">
      <IndexRedirect to="/en-us/banking/business/checking" />
    </Route>,
    <ModuleRoute component={Dls7Wrapper}>
      <Route path="/en-us/banking/error" component={ErrorMessage} />
    </ModuleRoute>,
    <ModuleRoute onEnter={onEnterBankingAccounts(store)}>
      <ModuleRoute component={Dls6Wrapper}>
        <ModuleRoute
          path="/en-us/banking/personal/checking"
          moduleName="banking-personal-checking-root"
        />
      </ModuleRoute>
    </ModuleRoute>,
    <ModuleRoute onEnter={onEnterBankingAccounts(store)}>
      <ModuleRoute
        path="/en-us/business/virtual-card"
        moduleName="axp-virtual-cards-root"
      />
    </ModuleRoute>,
    <ModuleRoute component={Dls6Wrapper}>
      <ModuleRoute path="/en-us/banking/atm-locator" moduleName="atm-locator" />
    </ModuleRoute>,
    <ModuleRoute component={Dls7Wrapper}>
      <ModuleRoute
        path="/en-us/banking/order-checkbook"
        moduleName="banking-business-checking-checkbook-order"
        onEnter={onEnterCheckbookOrder(store)}
      />
      <ModuleRoute
        path="/en-us/banking/business/onboarding"
        moduleName="banking-business-onboarding"
      />
    </ModuleRoute>,
    <ModuleRoute onEnter={onEnterBankingAccounts(store)}>
      <ModuleRoute
        path="/en-us/banking/business/:product"
        moduleName="banking-business-checking-root"
      />
    </ModuleRoute>,
    <ModuleRoute
      component={Dls6Wrapper}
      onEnter={onEnterBankingAccounts(store)}
    >
      <ModuleRoute
        path="/en-us/banking/personal/savings"
        moduleName="banking-personal-savings-root"
      />
    </ModuleRoute>,
    <ModuleRoute component={Dls6Wrapper}>
      <ModuleRoute
        path="/en-us/apply/upload-documents"
        moduleName="axp-global-document-upload"
      />
    </ModuleRoute>,
    <ModuleRoute component={Dls7Wrapper}>
      <ModuleRoute
        path="/en-us/business/blueprint/account"
        moduleName="business-blueprint-root"
      />
    </ModuleRoute>,
    <ModuleRoute component={Dls6Wrapper}>
      <ModuleRoute
        path="/en-us/banking/personal/apply/rate-sheet"
        moduleName="apply-experience-terms-and-conditions"
        config={{
          productType: 'BANKING',
          isOneCmsEnabled: true,
        }}
      />
    </ModuleRoute>,
  ];
};

export default childRoutes;
/* eslint-enable */
